import { render, staticRenderFns } from "./HeaderSearchButton.vue?vue&type=template&id=771bf5c4&"
import script from "./HeaderSearchButton.vue?vue&type=script&lang=js&"
export * from "./HeaderSearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports